import { ref } from 'vue'

export type Theme = 'dark' | 'light'

const stored =
  typeof localStorage !== 'undefined' ? localStorage.getItem('theme') : null
const prefersDark =
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-color-scheme: dark)').matches

export const theme = ref<Theme>(
  stored === 'light' || stored === 'dark' ? stored : prefersDark ? 'dark' : 'dark',
)

export function applyTheme(mode: Theme): void {
  theme.value = mode
  document.documentElement.classList.toggle('dark', mode === 'dark')
  try {
    localStorage.setItem('theme', mode)
  } catch {
    // ignore storage errors
  }
}

export function toggleTheme(): void {
  applyTheme(theme.value === 'dark' ? 'light' : 'dark')
}

export function initTheme(): void {
  applyTheme(theme.value)
}
